<template>
  <v-container
    fluid
    class="overlay"
  >
    <v-layout
      align-center
      justify-center
      column
    >
      <v-flex class="loading center">
        <h3>{{ strings.loading }}</h3>
      </v-flex>
      <v-flex class="loading">
        <v-progress-circular
          :size="50"
          color="secondary"
          indeterminate
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters("page", ["strings"])
  }
};
</script>

<style lang="less" scoped>
.overlay {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: #a0a0a0a0;
}

.overlay .loading {
  background-color: #fffffff7;
  padding: 1%;
  width: 50vw;
  height: 15vh;
  color: black;
}

.overlay .loading.center {
  margin-top: 40vh;
}

.overlay .loding-icon {
  background-color: #fffffff7;
  padding: 1%;
  color: #005387;
}
</style>
